export default __webpack_public_path__ + "static/media/COMLOGO2.079029bc.png";